import styled, { css } from "styled-components";

interface StyledDotProps {
  $color: string;
  $size: number;
}

export const StyledDot = styled.div<StyledDotProps>`
  border-radius: 100%;

  ${(props) =>
    props.$size &&
    css`
      width: ${props.$size}px;
      height: ${props.$size}px;
    `}

  ${(props) =>
    props.$color &&
    css`
      background-color: ${props.$color};
    `}
`;
